module.exports = __webpack_public_path__ + "img/tank-e-logo.1280370d.svg";